import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../components/common/Input";
import Button from "../../components/common/Button";
import { doctorLogin } from "../../redux/Reducer/authSlice";
import useFcmToken from "../../useFcmToken";

const fieldSchemas = {
  contactNumber: Yup.string()
    .required("Contact number is required")
    .matches(/^\d{10}$/, "Contact number must be exactly 10 digits"),

  pin: Yup.string()
    .required("PIN is required")
    .matches(/^\d{5}$/, "PIN must be a 5-digit."),
};
const DoctorLogIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    contactNumber: "",
    pin: "",
    // pinB: "",
  });
  const [formErrors, setFormErrors] = useState({
    contactNumber: "",
    pin: "",
  });

  const [isResetPin, setIsResetPin] = useState(false);
  const { fcmToken } = useFcmToken("doctor");
  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    try {
      await fieldSchemas[name].validate(value);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } catch (validationError) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationError.message,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData?.contactNumber) {
      errors.contactNumber = "Contact Number is required";
    }

    if (!formData?.pin) {
      errors.pin = "PIN is required";
    } else if (!/^\d{5}$/.test(formData.pin)) {
      errors.pin = "PIN must be a 5-digit ";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleLogin = () => {
    if (validateForm()) {
      if (navigator.onLine) {
        localStorage.setItem("doctorFcmToken", fcmToken);
        var payload = {
          contactNumber: formData.contactNumber,
          pin: formData.pin,
        };

        if (fcmToken) {
          payload.fcmToken = fcmToken;
        }
        dispatch(doctorLogin(payload));
      }
    }
  };

  // Redirect based on PIN type
  useEffect(() => {
    if (user) {
      if (user.isPinB) {
        navigate("/healthmap");
      } else {
        navigate("/studio");
      }
    }
  }, [user, navigate]);

  return (
    <section className="flex items-center h-[100vh]">
      <div className="container">
        <div className="flex items-center justify-center px-[25px]">
          <div className="max-w-[650px] max-h-[400px] w-full mx-auto relative">
            <div className="flex items-center flex-wrap">
              <div className="text-center w-full md:max-w-[297px] lg:w-[297px] md:pr-[33px] flex items-center justify-center max-md:mb-[30px]">
                <img
                  src="/logo.svg"
                  className="w-full h-[auto] md:max-w-[290px] max-w-[180px]"
                  alt="Logo"
                />
              </div>
              <div className="max-w-[95%] w-full h-[2px] md:w-[2px] md:h-full bg-primary-600 relative md:absolute max-md:mx-auto md:top-0 md:left-[297px] bottom-0 before:content-[''] before:block before:h-[4px] before:w-[4px] before:absolute before:top-0 before:-left-[1px] max-md:before:-top-[1px] before:rounded-full after:bg-primary-600 after:block after:h-[4px] after:w-[4px] after:absolute after:bottom-0 max-md:after:-bottom-[1px] after:-right-[1px] md:after:-left-[1px] after:rounded-full before:bg-primary-600"></div>
              <div className="w-full pt-[30px] md:w-[calc(100%_-_297px)] md:py-[49px] md:pl-[33px]">
                <div>
                  <h3 className="text-primary-600 text-[20px] font-medium mb-3">
                    Doctor Login
                  </h3>
                  {!isResetPin ? (
                    <>
                      {/* {error && <p className="text-red-500">{error}</p>} */}
                      <div className="mb-3">
                        <Input
                          placeholder="Enter"
                          type="number"
                          name="contactNumber"
                          value={formData.contactNumber}
                          labelName="Contact Number"
                          onChange={handleChange}
                          labelClassName="block text-primary-400 text-[13px] leading-[30px]"
                          className="mb-2 border-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                          isError={!!formErrors.contactNumber}
                          errorMessage={formErrors.contactNumber}
                        />
                      </div>
                      <div className="mb-2">
                        <Input
                          placeholder="Enter"
                          type="password"
                          name="pin"
                          value={formData.pin}
                          labelName="PIN (5-digit)"
                          onChange={handleChange}
                          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                          isError={!!formErrors.pin}
                          errorMessage={formErrors.pin}
                        />
                      </div>

                      <div className="flex items-center pt-1">
                        <Button
                          className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 hover:bg-primary-200 hover:border-primary-200 focus:border-primary-200 border-[4px] border-primary-600 shadow-none outline-none"
                          onClick={handleLogin}
                          disabled={loading}
                        >
                          Login
                        </Button>
                      </div>

                      <div className="pt-1">
                        <Button
                          className=" h-[36px] text-primary-500 lg:text-[16px] py-2  min-w-[136px] text-[13px]  underline shadow-none outline-none text-left pl-1.5"
                          onClick={() => setIsResetPin(true)}
                          type="button"
                        >
                          Reset Pin
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="text-[13px]">
                        Please contact admin to reset the pin
                      </p>
                      <div className="flex items-center pt-1">
                        <Button
                          className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 hover:bg-primary-200 hover:border-primary-200 focus:border-primary-200 border-[4px] border-primary-600 shadow-none outline-none"
                          onClick={() => setIsResetPin(false)}
                          type="button"
                        >
                          Ok
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorLogIn;
